import { getPublicApiUrl } from "./getPublicApiUrl";
import { getWidgetUrl } from "./getWidgetUrl";

export const awsAccountId = process.env.REACT_APP_FBT_AWS_ACCOUNT_ID;

export const isProduction = awsAccountId === "644084073510";
export const isApplause = awsAccountId === "266256754960";
export const isSandbox = awsAccountId === "627208980326";
export const isStaging = awsAccountId === "913709512847";
export const isQa = awsAccountId === "755386480951";

export const isLocal =
  window.location.href.indexOf("local.friendstore.com:9977") > -1;

// will look like "https://public.xxx.me"
export const PUBLIC_API_URL = getPublicApiUrl(awsAccountId);

export const maxCustomAttributes = 10;

export const localstoragePrefix = "__fby__";

export const sessionId =
  new Date().toISOString() + "|" + String(Math.random()).slice(2);

export const WIDGET_URL = isLocal
  ? "http://local.friendstore.com:9977/"
  : getWidgetUrl(awsAccountId);
